import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';
import { getPolicySummarySaga } from './getPolicySummarySaga';

export function* sendEmailRequestSaga({ payload }) {
    try {
        yield put(reduceLoading({ code: 'sendEmail', value: true }));
        const session = yield getSessionSaga();

        const response = yield call(fetch, '/api/clientnotification/send-email', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                policyTransactionGuid: payload.policyTransactionGuid,
                templateType: payload.templateType,
                documentAttachmentGuids: payload.documentAttachmentGuids,
            }),
        });

        const result = yield call([response, 'json']);

        yield call(getPolicySummarySaga);

        yield put(reduceOperation(result.operation));
    } catch (error) {
        console.error(error);
    } finally {
        yield put(reduceLoading({ code: 'sendEmail', value: false }));
    }
}
